import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconThumbsDown20Filled(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconThumbsDown20Filled"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M15.468 11.934a2.5 2.5 0 0 0 2.5-2.5V5.487a2.5 2.5 0 0 0-2.5-2.5h-.5v8.947zm-2 1.007V2.987H6.467a2.5 2.5 0 0 0-2.239 1.386L2.265 8.321c-.827 1.662.382 3.613 2.238 3.613h3.115l-.296 3.433c-.12 1.397 1.571 2.18 2.56 1.186z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconThumbsDown20Filled);
